import { mapState } from 'vuex';
import { cancelPrediction, generatePredictions, getPrediction } from '@/api/ai-tools.js';

export default {
  name: 'PredictionMixin',
  data() {
    return {
      output: null,
      isLoading: false,
      isPredictionLoading: false,
      isPredictionCanceled: false,
      predictionId: null,
      error: null,
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
      isProgress: state => state.leave.isProgress,
    }),
    isSamePrediction() {
      return this.form.image && _.isEqual(this.form, this.prediction);
    },
  },
  mounted() {
    const predictionId = this.$route.query.prediction_id;
    if (predictionId && this.isLoggedIn) {
      this.predictionId = predictionId;
      this.getPrediction();
    }
  },
  watch: {
    isPredictionLoading(isLoading) {
      this.$store.dispatch('leave/setIsProgress', isLoading);
    },
    isProgress(value) {
      console.log('leave/setIsProgress', value);
    },
    'form.image'(value) {
      if (value) {
        this.form.demoImage = null;
      }
    },
  },
  methods: {
    async generatePredictions() {
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;

      if (!this.$v.form.$invalid) {
        this.isLoading = true;
        this.$store.dispatch('leave/setIsProgress', true);
        this.output = null;
        this.isPredictionCanceled = false;

        await generatePredictions({
          ...this.form,
        })
          .then(async response => {
            console.log(response.data);
            const prediction = response.data.data;
            this.$store.dispatch('leave/setIsProgress', false);
            this.predictionId = prediction.id;
            this.$router.replace({ query: { ...this.$route.query, prediction_id: prediction.id } });
            this.isLoading = false;
            this.$store.dispatch('user/setCoins');
            await this.getPrediction();
          })
          .catch((error) => {
            console.error(error);
            this.error = _.get(error, 'response.data.errors[0].detail');
            this.isLoading = false;
            this.$store.dispatch('user/setCoins');
            this.$store.dispatch('leave/setIsProgress', false);
          });
      }
    },
    async getPrediction() {
      this.isPredictionLoading = true;
      getPrediction(this.predictionId)
        .then(async response => {
          const data = response.data.data;
          console.log(data);
          if (this.form.model && this.form.model !== _.get(data, 'model')) {
            this.clearQuery();
            this.isPredictionLoading = false;
            return;
          }
          // this.setFormFromResponse(data);
          if (this.isPredictionCanceled) {
            this.isPredictionLoading = false;
          } else if (data.status === 'succeeded') {
            this.isPredictionLoading = false;
            const output = _.get(data, 'output.urls');
            if (Array.isArray(output)) {
              this.output = output;
            } else if (output) {
              this.output = [output];
            }
            this.$store.dispatch('user/setCoins');
          } else if (data.status === 'failed') {
            this.isPredictionLoading = false;
            this.error = _.get(data, 'prediction.error', true);
            this.$store.dispatch('user/setCoins');
          } else {
            setTimeout(() => {
              if (!this.isPredictionCanceled) {
                this.getPrediction();
              }
            }, 3000);
          }
        })
        .catch((error) => {
          this.isPredictionLoading = false;
          this.$store.dispatch('user/setCoins');
          this.error = error;
          console.error(error);
        });
    },
    async cancelPrediction() {
      cancelPrediction(this.predictionId)
        .then(async response => {
          console.log(response);
          this.clearQuery();
          this.isPredictionCanceled = true;
          this.isPredictionLoading = false;
        })
        .catch(() => {})
        .finally(() => {
          this.isPredictionLoading = false;
        });
    },
    clearQuery() {
      this.$router.replace({ query: { ...this.$route.query, prediction_id: undefined } });
    },
    clearPrediction() {
      this.output = null;
      this.isLoading = false;
      this.isPredictionLoading = false;
      this.predictionId = null;
      this.error = null;
      this.clearForm();
      this.clearQuery();
    },
  },
};
